export const PERCENTAGE_OF_POINT_USED = 'custom7'
export const QUANTITY_LIMIT = 'custom1Dec'

export const CLOUDINARY_IMAGES = 'image4'
export const TEMPLATE_LABEL_NAMES = {
  WEB_LABEL_FILTER: 'Web Label Text-2',
  WEB_LABEL_TAG: 'Web Label Text-1',
}
